export default __webpack_public_path__ + "static/chats-31c1d6fd4ce38cbed39bd8fe74e6f0ab.png";